import { ParserHelper } from "../ParserHelper";
export class ScoreboardTennisParser {
    constructor() {
        this.scoresToDisplayForGamePart = { firstSetScore: 1, secondSetScore: 2, thirdSetScore: 3, fourthSetScore: 4, fifthSetScore: 5 };
    }
    static get instance() {
        if (!ScoreboardTennisParser._instance) {
            ScoreboardTennisParser._instance = new ScoreboardTennisParser();
        }
        return ScoreboardTennisParser._instance;
    }
    parse(sportEvent, isTeamSwap) {
        let onServe = ParserHelper.instance.getAdditionalScore(sportEvent, "onServe");
        const currentTennisScores = this.currentTennisScores(sportEvent.score);
        let additionalScoreData1 = ParserHelper.instance.getAdditionalScores(sportEvent, currentTennisScores, "1");
        let additionalScoreData2 = ParserHelper.instance.getAdditionalScores(sportEvent, currentTennisScores, "2");
        if (isTeamSwap) {
            return {
                onServe: this.swapOnServe(onServe),
                additionalScoreData1: additionalScoreData2,
                additionalScoreData2: additionalScoreData1
            };
        }
        return {
            onServe,
            additionalScoreData1,
            additionalScoreData2
        };
    }
    swapOnServe(onServe) {
        switch (Number(onServe)) {
            case 1: return "2";
            case 2: return "1";
        }
        return undefined;
    }
    currentTennisScores(score) {
        if (!score) {
            return [];
        }
        return Object.keys(this.scoresToDisplayForGamePart)
            .filter(scoreToDisplay => Object.keys(score.additionalScores)
            .filter(scoreKey => score.additionalScores[scoreKey] !== "0")
            .map(set => set.slice(0, set.length - 1))
            .indexOf(scoreToDisplay) > -1);
    }
}
;
//# sourceMappingURL=ScoreboardTennisParser.js.map